import 'vuetify/dist/vuetify.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/vuetify-theme.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import interceptorsSetup from './util/interceptor.js'
import VeeValidate from 'vee-validate'
import can from './can'
import Chart from 'chart.js'

import { domain, count, prettyDate, pluralize, formatCurrency, formatDate } from './filters'

const truncate = function (text, length, clamp) {
  clamp = clamp || '...'
  const node = document.createElement('div')
  node.innerHTML = text
  const content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}

Vue.filter('truncate', truncate)
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
Vue.filter('formatCurrency', formatCurrency)
Vue.filter('formatDate', formatDate)

Vue.config.productionTip = false


const chartVersion =
  (Chart && Chart.version) ||
  (Chart && Chart.default && Chart.default.version) ||
  (window.Chart && window.Chart.version)

console.log('Chart.js runtime version:', chartVersion)
console.log('Chart export keys:', Object.getOwnPropertyNames(Chart))

Vue.use(VeeValidate)
interceptorsSetup()
// Handle chunk load errors due to new deployments

window.addEventListener('error', function (e) {
  if (e.message && (e.message.includes('Loading chunk') || e.message.includes('ChunkLoadError'))) {
    console.log('Chunk loading error detected, refreshing...');
    window.location.reload();
  }
});


new Vue({
  router,
  store,
  vuetify,
  can,
  render: h => h(App)
}).$mount('#app')
